import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <motion.footer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5 }}
      className="relative z-10 border-t border-white/5 bg-[#050509]/80 backdrop-blur-sm"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-[#b3b3c2] text-center md:text-left">
            &copy; 2018 – {currentYear} SimplyGods Community. Toate drepturile rezervate.
          </p>
          
          <p className="text-sm text-[#b3b3c2] flex items-center gap-1">
            Made with <Heart className="w-4 h-4 text-[#fc6d00] fill-[#fc6d00]" /> pentru comunitate
          </p>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
